module.exports = __webpack_public_path__ + "media/images/athletes/1587-85ede8d1b4efcb54ef76e239cc056abc.png";